import { render } from "./SingleCard.vue?vue&type=template&id=56e9eb11&scoped=true"
import script from "./SingleCard.vue?vue&type=script&lang=js"
export * from "./SingleCard.vue?vue&type=script&lang=js"

import "./SingleCard.vue?vue&type=style&index=0&id=56e9eb11&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e9eb11"]])

export default __exports__